import { render, staticRenderFns } from "./IbHandwriting.vue?vue&type=template&id=496ede92&scoped=true"
import script from "./IbHandwriting.vue?vue&type=script&lang=js"
export * from "./IbHandwriting.vue?vue&type=script&lang=js"
import style0 from "./IbHandwriting.vue?vue&type=style&index=0&id=496ede92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ede92",
  null
  
)

export default component.exports